import DocViewer from '@/components/TaskHub/DocViewer.tsx';
import Main from '@/screens/Main.tsx';
import NewApplication from '@/screens/NewApplication.tsx';
import ApplicationHub from '@/screens/ApplicationHub.tsx';
import React from 'react';
import {useRoutes} from 'react-router-dom';
import {useAuth} from "@clerk/clerk-react";
import UserSwitcher from "@/components/UserSwitcher.js";
import Loading from "@/components/Loading.js";
import {useKayAuth} from "@/context/AuthContext.js";
import WebsiteSchemaTool from '@/components/WebsiteSchemaTool/WebsiteSchemaTool.tsx';

const AppRoutes: React.FC = () => {
  const {isSignedIn} = useAuth();
  const { ownUserId, user } = useKayAuth();

  const routes = useRoutes([
    {
      element: <Main/>,
      path: '*',
    },
    {
      element: <WebsiteSchemaTool />,
      path: '/tools/website'
    },
    {
      element: <NewApplication/>,
      path: '/home/new',
    },
    {
      element: <ApplicationHub/>,
      path: '/home/hub/*',
    },
    {
      element: <ApplicationHub/>,
      path: '/home/hub',
    },
  ]);

  if(!(isSignedIn && ownUserId)) {
    return (
      <Loading />
    )
  }

  if(!user) {
    return (
      <>
        <UserSwitcher noShow />
        <Loading />
      </>
    )
  }

  return (
    <>
      <>
        <UserSwitcher noShow />
        {routes}
      </>
      <DocViewer/>
    </>
  );
};

export default AppRoutes;
